import { useEffect } from 'react';
import withGlobalModal from '../GlobalModal/withGlobalModal';
import { MODAL_KEYS } from '../GlobalModal/modalSource';
import { LocalStorageKeys } from '../../utilities/storageUtils';
import useBrowserStorage from '../../hooks/ui_hooks/useBrowserStorage';

const IEModal = ({ openModal }) => {
  const [isIEModalAlreadyShown, setIEModalAlreadyShown] = useBrowserStorage(LocalStorageKeys.IE_IS_MODAL_SHOWN);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isIEBrowser = userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;

    if (isIEBrowser && !isIEModalAlreadyShown) {
      openModal(
        {
          keyContentComponent: MODAL_KEYS.IE_MODAL,
          params: {}
        },
        true
      );
      setIEModalAlreadyShown(true);
    }
  }, [isIEModalAlreadyShown, setIEModalAlreadyShown, openModal]);

  return null;
};

export default withGlobalModal(IEModal);
